<template>
  	<div id="app">
	  	<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
  	</div>
</template>
<script>
export default {
	name: 'app',
	data() {
		return {
		}
	}
}
</script>

<style lang="scss">
	@import "@/common/scss/element-variables.scss";
  	#app {
    	min-width: 1280px;
        height: 100%;
		background-color: #f7f7f7;
	}
</style>
